/**
 * Reduces a value to what a typed filter is matched against: lower case,
 * accents off, so "Rossi" finds "rossi" and "Nicolò" is found by "nicolo".
 */
export function normalizeForFilter(value: string | null | undefined): string {
  return (value ?? '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '');
}

/**
 * Whether one of the given texts contains the typed filter. An empty filter
 * matches everything — the box being empty means "show me all of it".
 */
export function matchesFilter(query: string, ...texts: (string | null | undefined)[]): boolean {
  const needle = normalizeForFilter(query).trim();
  if (!needle) return true;
  return texts.some((text) => normalizeForFilter(text).includes(needle));
}
